import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

@observer
export class AddBlockControls extends React.Component<{ store: X7PushableBlockStore }> {
  render() {
    const {store} = this.props;

    if (store.addBlock === null)
      return null;

    const addBlock = store.addBlock;
    const isFailure = addBlock.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Adding block" state={addBlock.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button"
                    className="btn btn-primary"
                    onClick={store.cancel}>
              Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
